<template>
  <section class="md:mb-8 lg:mb-16">
    <categories />

    <!-- Recipe list -->
    <items-header />
    <items :load-more-button="computedLoadMoreButton" />
  </section>
</template>

<script>
import { computed, watch } from 'vue'

import Items from '@/components/search/SearchItems.vue'
import Categories from '@/components/search/SearchCategories.vue'
import ItemsHeader from '@/components/search/SearchItemsHeader.vue'

import router from '@/compositions/recipes/RecipeRouter'
import searchQueryState from '@/compositions/search/SearchQuery'
import searchConfig from '@/compositions/search/SearchConfiguration'
import routerHelper from '@/compositions/search/SearchRouterHelper'
import searchFactory from '@/compositions/search/SearchFactory'

export default {
  router,
  components: {
    Categories,
    Items,
    ItemsHeader
  },
  props: {
    searchConfiguration: {
      type: Object,
      required: true
    },
    language: {
      type: String,
      required: true
    },
    baseUrl: {
      type: String,
      required: true
    },
    loadMoreButton: {
      type: Object,
      required: true
    },
    initialSearchResult: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const { getActiveConfig } = searchConfig.searchConfigurationUse([props.searchConfiguration])
    const { getRouteData, updateRoute } = routerHelper.useRouterHelper(router, props.baseUrl)
    const routeData = getRouteData(router)
    routeData.language = props.language
    const {
      skip,
      itemsCount: take
    } = props.loadMoreButton
    const searchQuery = {
      ...routeData,
      take,
      skip
    }

    const { searchQuery: queryState } = searchQueryState.searchQueryUse(searchQuery)
    searchFactory.initialize(props.initialSearchResult)
    const { loading } = searchFactory.useSearchResult()

    // With JS enabled, selecting a category is an in-page SPA route change, so the
    // server-rendered nextPageUrl goes stale. Rebuild it from the currently active
    // categories (path segment) and the live paging state so the link keeps the filter.
    const computedLoadMoreButton = computed(() => {
      const activeSlugs = getActiveConfig().categories
        .flatMap((group) => group.categories)
        .filter((category) => queryState.activeCategories.includes(category.name))
        .map((category) => category.slug)
        .filter((slug) => slug)
        .sort()
      const path = activeSlugs.length
        ? `${props.baseUrl}${activeSlugs.join('+')}/`
        : props.baseUrl
      return {
        ...props.loadMoreButton,
        nextPageUrl: `${path}?skip=${queryState.skip + queryState.take}`
      }
    })

    watch(
      () => [loading.value],
      () => {
        if (!loading.value) {
          updateRoute()
        }
      }
    )
    return {
      loading,
      routeData,
      computedLoadMoreButton
    }
  }
}
</script>
